<template>
  <div class="card mb-25 border-0 radius-7 bg-white sales-pos-location-box">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <div
        class="mb-15 mb-sm-0 d-sm-flex align-items-center justify-content-between"
      >
        <div class="title">
          <span class="fw-medium text-muted fs-13 d-block mb-5 text-uppercase">
            {{ getMetricsToday.day_of_week_name }}
          </span>
          <h4 class="card-title fw-black mb-0">({{ getMetricsToday.day_of_year }}/365)</h4>
        </div>
      </div>
      <div id="weeklySalesChart" class="chart">
        <apexchart
          type="area"
          height="375"
          :options="weeklySalesChart"
          :series="[
            {
              name: 'UPLOADS COM SUCESSO', 
              data: Object.values(getMetricsHours).map(hour => hour.total_success)
            },
            {
              name: 'UPLOADS COM ERRO', 
              data: Object.values(getMetricsHours).map(hour => hour.total_error)
            },
          ]"
        ></apexchart>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { mapGetters } from 'vuex';

export default defineComponent({
  name: "UploadTotalsHour",
  data: function () {
    return {
      weeklySalesChart: {
        chart: {
          zoom: {
            enabled: false,
          },
          toolbar: {
            show: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "smooth",
          width: 2
        },
        fill: {
          type: 'gradient',
          gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.7,
            opacityTo: 0.9,
            stops: [0, 90, 100]
          }
        },
        colors: ["#159269", "#C33F52"],
        legend: {
          position: "top",
          fontSize: "14px",
          fontWeight: 500,
          horizontalAlign: "center",
          fontFamily: "Red Hat Display, sans-serif",
          labels: {
            colors: "#607089",
          },
          markers: {
            offsetY: -1,
            offsetX: -4,
            height: 15,
            width: 15
          },
          itemMargin: {
            horizontal: 10,
          },
        },
        grid: {
          show: true,
          strokeDashArray: 5,
          borderColor: "#dfe7f1",
        },
        tooltip: {
          style: {
            fontSize: "14px",
            fontFamily: "Red Hat Display, sans-serif",
          }
        },
        xaxis: {
          categories: ["00:00", "01:00", "02:00", "03:00", "04:00", "05:00", "06:00", "07:00", "08:00", "09:00", "10:00", "11:00", "12:00", "13:00", "14:00", "15:00", "16:00", "17:00", "18:00", "19:00", "20:00", "21:00", "22:00", "23:00"],
          labels: {
            show: true,
            style: {
              fontFamily: "Red Hat Display, sans-serif",
              colors: "#607089",
              fontSize: "14px",
              fontWeight: 500,
            },
          },
          axisTicks: {
            show: false,
          },
          axisBorder: {
            show: false,
          },
          tooltip: {
            style: {
              fontFamily: "Red Hat Display, sans-serif",
              colors: "#10223b",
              fontSize: "14px",
            },
          },
        },
        yaxis: {
          show: true,
          labels: {
            style: {
              fontFamily: "Red Hat Display, sans-serif",
              colors: ["#607089"],
              fontSize: "14px",
              fontWeight: 500,
            },
            formatter: function (value) {
              return Math.round(value);
            }
          },
        },
      },
    };
  },
  computed:{
    ...mapGetters([
      'getMetricsHours',
      'getMetricsToday'
    ])
  },
});
</script>
